<template>
    <div id="add">
        <div class="box">
            <div id="title" class="title has-text-grey-dark"><i class="fa fa-th-list"></i> Sentences</div>
        </div>
        <hr>
        <form class="box">
            <div class="columns is-multiline">

                <div class="column is-8">
                    <div class="field">
                        <textarea class="is-primary textarea" name="text" v-model="premadeSentence.text"  v-validate="'required'"  v-bind:class="{'input': true, 'is-danger': errors.has('text') }"
                                  type="text"
                                  placeholder="Text"></textarea>
                        <transition name="fade-fast">
                            <span v-show="errors.has('text')" class="help is-danger">{{ errors.first('text') }}</span>
                        </transition>
                        <div class="p5">
                          <span class="help">In order to make sentences viable for any student, use magic templates like shown below <span class="has-text-info">(click on any of items in order to add it to sentence above)</span>:</span>
                          <span class="help" v-for="(item, index) in magicWords"><a @click="addToSentence(item.alias)"  href="javascript:{}" v-html="item.alias"></a> - <span v-html="item.description"></span></span>
                        </div>
                    </div>
                </div>
                <div class="column is-4">
                    <div class="field">
                        <multiselect v-model="premadeSentence.premadeCategories[0]" label="name" track-by="name" name="categories" placeholder="Choose category" :options="premadeCategories" :multiple="false"></multiselect>
                    </div>
                </div>

            </div>
            <div class="columns is-multiline">
                <div class="column is-6">
                    <div class="field">
                        <multiselect placeholder="Choose schools" v-model="premadeSentence.schools" label="name" track-by="name" name="schools" :options="schools" :multiple="true"></multiselect>
                    </div>
                </div>
                <div class="column is-2  is-offset-2">
                    <loading-button v-bind:loading="loading" color="is-info" @click="save()">Save</loading-button>
                </div>
                <div class="column is-2">
                    <a href="javascript:history.go(-1)" class="button is-block">
                        Back
                    </a>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import lodash from 'lodash'

export default {
  name: 'premade-sentences-add',
  components: {},
  data() {
        return {
            loading: false,
            schools :[],
            magicWords :[],
            premadeSentences: {},
            premadeSentence: {schools :[], premadeCategories :[], text:'' },
            premadeCategories :[]
        }
  },
  created(){
    this.loadSchools();
    this.loadMagicWords();
  },
  methods: {

    save(){
        this.$validator.validateAll().then((result) => {
	        if (result) {
                let self = this;
                this.loading = true;
                this.premadeSentenceRepo.store(this.premadeSentence).then(function (response) {
                    self.loading = false;
                    self.$toast.success(response.data.message);
                    self.$router.push('/dashboard/premade-sentences');
                }).catch(function(response){
                    self.loading = false;
                    return Promise.reject(response);
                });
            }
        });

    },
      loadSchools(){
          this.loading = true;
          this.schoolRepo.all().then(response => {
              this.schools = response.data.data;
              this.loading = false;
              this.loadPremadeCategories();

          }).catch((response) =>{
              this.loading = false;
              return Promise.reject(response);
          });
      },
      loadMagicWords(){
          this.loading = true;
          this.magicWordRepo.all().then(response => {
              this.magicWords = response.data.data;
              this.loading = false;
          }).catch((response) =>{
              this.loading = false;
              return Promise.reject(response);
          });
      },
      loadPremadeCategories(){
          this.loading = true;
          this.premadeCategoryRepo.all().then(response => {
              this.premadeCategories = response.data.data;
              this.loading = false;
          }).catch((response) =>{
              this.loading = false;
              return Promise.reject(response);
          });
      },
      addToSentence(text){
        this.premadeSentence.text = this.premadeSentence.text + text;
      },
  },
  watch: {

  }

}
</script>

<style lang="css" scoped>

</style>



// WEBPACK FOOTER //
// src/components/premade-sentences/Add.vue